import { render, staticRenderFns } from "./addressCom.vue?vue&type=template&id=84288e86&scoped=true"
import script from "./addressCom.vue?vue&type=script&lang=js"
export * from "./addressCom.vue?vue&type=script&lang=js"
import style0 from "./addressCom.vue?vue&type=style&index=0&id=84288e86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84288e86",
  null
  
)

export default component.exports